import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const GoodsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`
export const GoodListContainer = styled.div`
    display: flex;
    padding-top: 1rem;
`
export const GoodList = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 1rem;
    width: 100%;
`
export const SearchTitle = styled.div`
    color: ${ThemeColors.getGrayColor(0.7)};
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    padding: 3rem;
`
